import React from "react";
import "@/App.css";
import "./styles/premium.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AssistantProvider } from "./components/assistant/WarenProAssistant";
import ProtectedRoute from "./components/ProtectedRoute";
import { loadPage } from "./lib/loadPage";
import { Toaster } from "sonner";

import Login from "./pages/Login";
const Dashboard = loadPage(() => import("./pages/Dashboard"));
const Products = loadPage(() => import("./pages/Products"));
const Suppliers = loadPage(() => import("./pages/Suppliers"));
const Sales = loadPage(() => import("./pages/Sales"));
const Marketplaces = loadPage(() => import("./pages/Marketplaces"));
const Pricing = loadPage(() => import("./pages/Pricing"));
const Settlements = loadPage(() => import("./pages/Settlements"));
const Users = loadPage(() => import("./pages/Users"));
const Parties = loadPage(() => import("./pages/Parties"));
const Settings = loadPage(() => import("./pages/Settings"));
const Warehouse = loadPage(() => import("./pages/Warehouse"));
const Pallets = loadPage(() => import("./pages/Pallets"));
const Companies = loadPage(() => import("./pages/Companies"));
const Reports = loadPage(() => import("./pages/Reports"));
const Analytics = loadPage(() => import("./pages/Analytics"));
const Accounting = loadPage(() => import("./pages/Accounting"));
const PurchaseOrders = loadPage(() => import("./pages/PurchaseOrders"));
const Postens = loadPage(() => import("./pages/Postens"));
const Customers = loadPage(() => import("./pages/Customers"));
const Invoices = loadPage(() => import("./pages/Invoices"));
const Returns = loadPage(() => import("./pages/Returns"));
const ReturnPortal = loadPage(() => import("./pages/ReturnPortal"));
const SetupPassword = loadPage(() => import("./pages/SetupPassword"));
const MyAccount = loadPage(() => import("./pages/MyAccount"));
const ShippingMonitor = loadPage(() => import("./pages/ShippingMonitor"));
const Shipping = loadPage(() => import("./pages/Shipping"));
const PickingList = loadPage(() => import("./pages/PickingList"));
const Replacements = loadPage(() => import("./pages/Replacements"));
const EbayQueue = loadPage(() => import("./pages/EbayQueue"));

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASENAME || undefined}>
          <AssistantProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup-password" element={<SetupPassword />} />
            <Route path="/retoure" element={<ReturnPortal />} />
            <Route path="/retouren" element={<ProtectedRoute roles={["admin","sales","accounting"]}><Returns /></ProtectedRoute>} />
            <Route path="/ersatzlieferungen" element={<ProtectedRoute roles={["admin","sales","warehouse"]}><Replacements /></ProtectedRoute>} />
            <Route path="/" element={<ProtectedRoute roles={["admin"]}><Dashboard /></ProtectedRoute>} />
            <Route path="/mein-konto" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
            <Route path="/versand/monitor" element={<ProtectedRoute><ShippingMonitor /></ProtectedRoute>} />
            <Route path="/versand/einstellungen" element={<ProtectedRoute roles={["admin","warehouse"]}><Shipping /></ProtectedRoute>} />
            <Route path="/pickliste" element={<ProtectedRoute roles={["admin","warehouse"]}><PickingList /></ProtectedRoute>} />
            <Route path="/artikel" element={<ProtectedRoute><Products /></ProtectedRoute>} />
            <Route path="/lieferanten" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/verkauf" element={<ProtectedRoute><Sales /></ProtectedRoute>} />
            <Route path="/kunden" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/rechnungen" element={<ProtectedRoute roles={["admin","accounting","sales"]}><Invoices /></ProtectedRoute>} />
            <Route path="/marktplaetze" element={<ProtectedRoute><Marketplaces /></ProtectedRoute>} />
            <Route path="/preisregeln" element={<ProtectedRoute roles={["admin","sales"]}><Pricing /></ProtectedRoute>} />
            <Route path="/ebay" element={<ProtectedRoute roles={["admin","sales"]}><EbayQueue /></ProtectedRoute>} />
            <Route path="/abrechnungen" element={<ProtectedRoute><Settlements /></ProtectedRoute>} />
            <Route path="/einkauf" element={<ProtectedRoute roles={["admin","warehouse"]}><PurchaseOrders /></ProtectedRoute>} />
            <Route path="/posten" element={<ProtectedRoute roles={["admin","warehouse","accounting"]}><Postens /></ProtectedRoute>} />
            <Route path="/parteien" element={<ProtectedRoute><Parties /></ProtectedRoute>} />
            <Route path="/lagerverwaltung" element={<ProtectedRoute roles={["admin","warehouse"]}><Warehouse /></ProtectedRoute>} />
            <Route path="/paletten" element={<ProtectedRoute roles={["admin","warehouse"]}><Pallets /></ProtectedRoute>} />
            <Route path="/firmen" element={<ProtectedRoute roles={["admin"]}><Companies /></ProtectedRoute>} />
            <Route path="/berichte" element={<ProtectedRoute roles={["admin","accounting"]}><Reports /></ProtectedRoute>} />
            <Route path="/auswertungen" element={<ProtectedRoute roles={["admin","accounting"]}><Analytics /></ProtectedRoute>} />
            <Route path="/buchhaltung" element={<ProtectedRoute roles={["admin","accounting"]}><Accounting /></ProtectedRoute>} />
            <Route path="/benutzer" element={<ProtectedRoute><Users /></ProtectedRoute>} />
            <Route path="/einstellungen" element={<ProtectedRoute roles={["admin"]}><Settings /></ProtectedRoute>} />
          </Routes>
          </AssistantProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
